import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Zap, Check, Crown, Sparkles, Gift } from 'lucide-react';

const BonusTrialModal = ({ isOpen, onClose, onAccept, offer, loading }) => {
  if (!offer) return null;

  const { bonus_days, new_limit, features, cta_message } = offer;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-center justify-center">
            <Gift className="w-6 h-6 text-purple-600" />
            <span>Special Offer Just For You!</span>
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          {/* Hero section */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 mb-4">
              <Crown className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Unlock Advanced Features
            </h3>
            <p className="text-gray-600">
              You&apos;re making great progress! Try our Advanced plan free for{' '}
              <span className="font-bold text-purple-600">{bonus_days} days</span>.
            </p>
          </div>

          {/* Features list */}
          <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-purple-600" />
              What you&apos;ll get:
            </h4>
            <ul className="space-y-2">
              {features?.map((feature, index) => (
                <li key={index} className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Upgrade info */}
          <div className="flex items-center justify-between bg-gray-50 rounded-lg p-3 mb-6">
            <div>
              <p className="text-xs text-gray-500">Your new limit</p>
              <p className="text-lg font-bold text-gray-900">
                Up to {new_limit} active items
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500">Free trial</p>
              <p className="text-lg font-bold text-purple-600">
                {bonus_days} days
              </p>
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex flex-col gap-3">
            <Button
              onClick={onAccept}
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white py-3"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin">⏳</span>
                  Activating...
                </span>
              ) : (
                <span className="flex items-center gap-2 justify-center">
                  <Zap className="w-5 h-5" />
                  {cta_message || `Start ${bonus_days}-Day Free Trial`}
                </span>
              )}
            </Button>
            
            <Button
              variant="ghost"
              onClick={onClose}
              disabled={loading}
              className="w-full text-gray-500 hover:text-gray-700"
            >
              Maybe later
            </Button>
          </div>

          {/* Fine print */}
          <p className="text-xs text-center text-gray-400 mt-4">
            No credit card required. Cancel anytime.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BonusTrialModal;
